import { colorSystem, generateThemeObjects } from './colorSystem';

export const contentData = {
  hero: {
    tag: "Chicago's Voice Since 1963",
    title: "Reach 185,000+ Engaged Chicagoans Who Shape the Community",
    description: "Connect with Chicago's most influential African-American audience through WVON 1690 AM – The Talk of Chicago for over 60 years",
    ctaText: "Explore Advertising Options",
    stats: [
      { key: "185K+", value: "Weekly Listeners" },
      { key: "60+", value: "Years of Trust" },
      { key: "13K+", value: "Monthly Website Visits" }
    ]
  },
  
  audience: {
    title: "Your Next Customers: Educated, Engaged, and Ready to Act",
    description: "Our listeners don't just live in Chicago – they shape it. Business leaders, culture makers, and informed citizens who turn to us for the stories that matter.",
    demographicsCharts: [
      {
        title: "Listener Demographics",
        items: [
          { label: "25–34", percentage: 15 },
          { label: "35–44", percentage: 25 },
          { label: "45–54", percentage: 35 },
          { label: "55–64", percentage: 20 },
          { label: "65+", percentage: 5 }
        ]
      }
    ],
    smallStats: [
      { value: "55%", label: "Female decision-makers" },
      { value: "65%", label: "College-educated professionals" },
      { value: "52%", label: "Earn $50K+ annually" },
      { value: "63%", label: "Access via mobile devices" },
      { value: "40-55", label: "Average age prime spending years" }
    ]
  },

  testimonials: {
    title: "Success Stories from Our Partners",
    description: "See how businesses grow with WVON's engaged audience",
    testimonials: [
      { 
        name: "David Cohen", 
        title: "Former EVP", 
        company: "Comcast Universal", 
        quote: "Large companies do themselves a disservice by overlooking WVON. They're a vital voice in the marketplace and know how to reach the people that count.",
        result: null,
        metric: null
      },
      { 
        name: "Chef Cliff Rhome", 
        title: "Owner", 
        company: "Peaches Restaurant", 
        quote: "After WVON's live broadcast, we had our largest revenue day ever. Their listeners continue supporting us with repeat business.",
        result: "Largest revenue day",
        metric: "Ever recorded"
      },
      { 
        name: "Maria Pappas", 
        title: "Cook County Treasurer", 
        company: "Cook County", 
        quote: "We're up to $300 million in refunds to Cook County homeowners due to our Black Houses Matters program on WVON. This is what public service is all about.",
        result: "$300 million",
        metric: "In homeowner refunds"
      },
      { 
        name: "Ted London", 
        title: "Principal", 
        company: "Law Offices", 
        quote: "We've built Illinois's largest estate planning law firm through our WVON partnership. Started as one-man operation 12 years ago.",
        result: "Illinois's largest",
        metric: "Estate planning firm"
      },
      { 
        name: "Steven Shaw", 
        title: "Representative", 
        company: "Verizon", 
        quote: "When it comes to building relationships with community, WVON is the right partnership.",
        result: null,
        metric: null
      }
    ]
  },

  inventory: {
    title: "Radio-Focused Advertising Solutions",
    description: "Reach Chicago's most engaged African-American audience across all touchpoints.",
    tabs: [
      {
        id: "radio",
        label: "Radio Advertising",
        isActive: true,
        title: "Radio Advertising",
        description: "Connect with 185,000+ weekly listeners through prime drive time and targeted programming.",
        stats: [
          { value: "Reach", label: "185K+ weekly listeners" },
          { value: "Demographics", label: "40-55 prime spending years" },
          { value: "Engagement", label: "High listener loyalty" }
        ]
      },
      {
        id: "vontv",
        label: "VONtv Streaming",
        isActive: true,
        title: "VONtv Streaming",
        description: "First Black-owned streaming platform reaching 117M+ households nationwide via ROKU, Amazon Fire, Apple TV+.",
        stats: [
          { value: "Reach", label: "117M+ household reach" },
          { value: "Platforms", label: "ROKU, Amazon Fire, Apple TV+" },
          { value: "Content", label: "Original programming, documentaries" },
          { value: "Impact", label: "1.2M+ campaign impressions" }
        ]
      },
      {
        id: "social",
        label: "Social Media",
        isActive: true,
        title: "Social Media",
        description: "Engage directly with Chicago's African-American community through our social media channels.",
        stats: [
          { value: "Engagement", label: "Direct community connection" },
          { value: "Platforms", label: "Facebook, Twitter, Instagram" },
          { value: "Content", label: "Live event coverage" },
          { value: "Reach", label: "Organic community sharing" }
        ]
      },
      {
        id: "events",
        label: "Event Sponsorships",
        isActive: true,
        title: "Event Sponsorships",
        description: "Create face-to-face connections through our community events and live broadcast opportunities.",
        stats: [
          { value: "Format", label: "Live broadcasts and events" },
          { value: "Community", label: "Face-to-face connections" },
          { value: "Impact", label: "Direct audience engagement" },
          { value: "Support", label: "Full event promotion" }
        ]
      }
    ]
  },

  campaign: {
    title: "Build Your WVON Campaign",
    description: "Connect with Chicago's most influential African-American audience through custom radio and streaming solutions.",
    planningCard: {
      title: "Get Your Custom WVON Media Plan",
      features: [
        "CONNECT: Share your goals with our team",
        "CREATE: We'll develop your custom media plan", 
        "CONVERT: Launch and track your success"
      ],
      ctaText: "Get Your Custom Proposal"
    }
  },

  contactFAQ: {
    contactTitle: "Get in Touch with WVON 1690 AM",
    contactDescription: "Ready to reach Chicago's most engaged African-American audience? Contact our advertising team to create a custom plan for your business.",
    contactInfo: {
      phone: "(773) 247-6200",
      email: "advertising@wvon.com",
      address: "3350 S. Kedzie Ave. Chicago, IL 60623"
    },
    faqTitle: "Frequently Asked Questions",
    faqItems: [
      {
        question: "What makes WVON different from other Chicago radio?",
        answer: "60+ year legacy as Chicago's only Black-owned talk radio station with deep community trust and 185K+ weekly engaged listeners"
      },
      {
        question: "How quickly can my radio campaign get started?",
        answer: "Most radio campaigns can launch within 48–72 hours of approval. We'll work with you to create compelling content that resonates with our audience."
      },
      {
        question: "What's the typical campaign timeline?",
        answer: "Radio campaigns launch within 5–7 business days; VONtv streaming may require 2–3 weeks for custom content"
      },
      {
        question: "Do you offer package deals?",
        answer: "Yes, radio and VONtv streaming packages available with volume discounts"
      },
      {
        question: "Can you help with creative development?",
        answer: "Full creative services available including radio production and VONtv streaming content creation"
      },
      {
        question: "How do you measure campaign success?",
        answer: "Detailed reporting on reach, frequency, audience engagement, plus custom KPIs for radio and streaming"
      }
    ]
  },

  aboutUs: {
    title: "The Voice of the Nation Since 1963",
    description: "WVON 1690 AM has been Chicago's essential storyteller since 1963, chronicling the rich history of the Black experience. As 'The Voice of the Nation,' we've launched careers from Barack Obama to Don Cornelius, covered the Civil Rights Movement, and remain the trusted platform for Chicago's African-American community. Today, we're more than a radio station – we're builders of community. Our award-winning hosts like Rufus Williams, Cleopatra Draper, Matt McGill, and Rev. Al Sharpton deliver intellectually ground-breaking content that educates, empowers, and engages. As a Black and female-owned enterprise led by Melody Spann-Cooper, we understand our community's pulse and provide advertisers authentic connections to this vital market.",
    imageUrl: "/aboutus.png"
  },

  footer: {
    contactInfo: {
      phone: "(773) 247-6200",
      email: "advertising@wvon.com", 
      address: "3350 S. Kedzie Ave. Chicago, IL 60623"
    },
    socialLinks: {
      linkedin: "https://www.linkedin.com/company/wvon-1690am/",
      twitter: "https://x.com/wvon1690",
      facebook: "https://www.facebook.com/WVON1690AM/"
    },
    companyName: "WVON 1690 AM",
    description: "Chicago's Voice of the Nation - Serving the African-American community with trusted talk radio since 1963"
  }
};

export const themeData = {
  // Design system values
  gradStart: colorSystem.darkGradient.start,
  gradEnd: colorSystem.darkGradient.end,
  angle: colorSystem.darkGradient.angle,
  fontFamily: "primary", // Libre Baskerville via font system
  radius: 4,
  iconWeight: "duotone",
  
  // Assets
  imageUrl: "/hero.jpg",
  logoUrl: "/wvon_logo.png",
  
  // Navigation
  navItems: [
    { id: "audience", label: "Our Audience", href: "#audience" },
    { id: "advertise", label: "Advertise", href: "#inventory" },
    { id: "aboutus", label: "About", href: "#aboutus" }
  ],
  ctaText: "Contact",
  ctaHref: "#contactfaq",
  
  // Section settings
  sectionSettings: {
    hero: { surface: "white", primary: "light" },
    audience: { surface: "light", primary: "light" },
    testimonials: { surface: "dark", primary: "dark" },
    inventory: { surface: "light", primary: "light" },
    campaign: { surface: "dark", primary: "dark" },
    contactfaq: { surface: "light", primary: "light" },
    aboutus: { surface: "light", primary: "light" },
    footer: { surface: "dark", primary: "dark" }
  },
  
  // Theme colors - now generated from centralized system
  ...generateThemeObjects(colorSystem.primary)
};
